'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.requestLogout = exports.requestLoginIfNeeded = exports.failureLogin = exports.receiveLogin = exports.requestLogin = exports.REQUEST_LOGOUT = exports.FAILURE_LOGIN = exports.RECEIVE_LOGIN = exports.REQUEST_LOGIN = undefined;

var _css = require('antd/lib/message/style/css');

var _message = require('antd/lib/message');

var _message2 = _interopRequireDefault(_message);

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; /**
                                                                                                                                                                                                                                                                   * 登录、注销相关Actions
                                                                                                                                                                                                                                                                   */


var _moment = require('moment');

var _moment2 = _interopRequireDefault(_moment);

var _api = require('../api');

var _utils = require('../utils');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var REQUEST_LOGIN = exports.REQUEST_LOGIN = 'REQUEST_LOGIN';
var RECEIVE_LOGIN = exports.RECEIVE_LOGIN = 'RECEIVE_LOGIN';
var FAILURE_LOGIN = exports.FAILURE_LOGIN = 'FAILURE_LOGIN';

var REQUEST_LOGOUT = exports.REQUEST_LOGOUT = 'REQUEST_LOGOUT';

var requestLogin = exports.requestLogin = function requestLogin(profile) {
    return {
        type: REQUEST_LOGIN,
        profile: profile
    };
};

var receiveLogin = exports.receiveLogin = function receiveLogin(profile, json) {
    if (profile.remember) {
        // 将用户信息存在localStorage，并记录过期时间，实现三天内自动登录
        _utils.ls.setItem('auth', _extends({}, profile, {
            isFetching: undefined,
            exp: +(0, _moment2.default)().add(3, 'd')
        }));
    }
    // 将token存在localStorage中，供后续API使用
    _utils.ls.setItem('token', json.token);

    return {
        type: RECEIVE_LOGIN,
        token: json.token,
        email: profile.email,
        received_at: +(0, _moment2.default)()
    };
};
var failureLogin = exports.failureLogin = function failureLogin(error) {
    var ok = error.ok,
        status = error.status,
        statusText = error.statusText,
        type = error.type,
        url = error.url;

    return {
        type: FAILURE_LOGIN,
        error: { ok: ok, status: status, statusText: statusText, type: type, url: url }
    };
};

var shouldRequestLogin = function shouldRequestLogin(state) {
    var auth = state.auth;
    if (auth.isFetching) {
        return false;
    }
    return true;
};

var requestLoginIfNeeded = exports.requestLoginIfNeeded = function requestLoginIfNeeded(profile) {
    return function (dispatch, getState) {
        if (shouldRequestLogin(getState(), profile)) {
            return dispatch(function (dispatch) {
                dispatch(requestLogin(profile));
                return (0, _api.login)(profile).then(function (response) {
                    return dispatch(receiveLogin(profile, response.data));
                }).catch(function (error) {
                    if (error.response && error.response.data) {
                        _message2.default.error('\u767B\u5F55\u5931\u8D25\uFF1A' + error.response.data.error);
                    } else if (error.request) {
                        _message2.default.error('\u767B\u5F55\u5931\u8D25\uFF1A\u7F51\u7EDC\u9519\u8BEF' + error.request);
                    } else {
                        _message2.default.error('\u767B\u5F55\u5931\u8D25\uFF1A' + error.message);
                    }
                    dispatch(failureLogin(error));
                });
            });
        }
    };
};

var requestLogout = exports.requestLogout = function requestLogout() {
    _utils.ls.removeItem('auth');
    _utils.ls.removeItem('token');
    return {
        type: REQUEST_LOGOUT
    };
};


//////////////////
// WEBPACK FOOTER
// ./src/js/actions/auth.js
// module id = 890
// module chunks = 0